import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { portfolioData } from "./data/mock";

// Import components
import Navigation from "./components/Navigation";
import MainPortfolio from "./components/MainPortfolio";
import AboutSection from "./components/AboutSection";
import CoffeeChat from "./components/CoffeeChat";
import TerminalIntro from "./components/TerminalIntro";

function App() {
  const [showIntro, setShowIntro] = useState(false);
  const [introComplete, setIntroComplete] = useState(false);

  useEffect(() => {
    // Check if user has seen the intro before
    const hasSeenIntro = localStorage.getItem('hasSeenIntro');
    if (!hasSeenIntro) {
      setShowIntro(true);
    } else {
      setIntroComplete(true);
    }
  }, []);

  const handleIntroComplete = () => {
    setShowIntro(false);
    setIntroComplete(true);
  };

  return (
    <div className="App">
      {showIntro && <TerminalIntro onComplete={handleIntroComplete} />}
      
      {introComplete && (
        <BrowserRouter>
          <Navigation />
          <Routes>
            <Route path="/" element={<AboutSection portfolioData={portfolioData} />} />
            <Route path="/portfolio" element={<MainPortfolio portfolioData={portfolioData} />} />
            <Route 
              path="/coffee-chat" 
              element={
                <div className="min-h-screen bg-slate-950 pt-20">
                  <CoffeeChat />
                </div>
              } 
            />
          </Routes>
        </BrowserRouter>
      )}
      
      <Toaster />
    </div>
  );
}

export default App;
